import React, { useState, useEffect, useRef } from "react";

export default function Map({ options, onMount, className, onMountProps }) {
  const ref = useRef();
  const [map, setMap] = useState();
  useEffect(() => {
    const onLoad = () => setMap(new window.google.maps.Map(ref.current, options));
    if (!window.google) {
      const script = document.createElement(`script`);
      script.src = `https://maps.googleapis.com/maps/api/js?key=` + process.env.GOOGLE_MAPS_API_KEY;
      document.head.append(script);
      script.addEventListener(`load`, onLoad);
      return () => script.removeEventListener(`load`, onLoad);
    } else onLoad();
  }, [options]);
  if (map && typeof onMount === `function`) onMount(map, onMountProps);
  return <div style={{ width: "100%", height: "100%" }} {...{ ref, className }} />;
}

Map.defaultProps = {
  options: {
    center: { lat: 43.66336, lng: -79.3444352 },
    zoom: 16,
    disableDefaultUI: true,
  },
};
